/**
 * @file
 * @see {@link https://www.iana.org/assignments/media-types/media-types.xhtml IANA Media Types}
 */

import { Type } from "./core";

/**
 * application
 */
export const ApplicationType = new Type("application");

/**
 * application/json
 * @see {@link https://www.iana.org/assignments/media-type/application/json IANA Media Types application/json}
 */
export const ApplicationJsonType = ApplicationType.subtype("json");

/**
 * application/x-www-form-urlencoded
 * @see {@link https://www.iana.org/assignments/media-types/application/x-www-form-urlencoded IANA Media Types applicaion/x-www-form-urlencoded }
 */
export const ApplicationXWwwFormUrlEncodedType = ApplicationType.subtype(
  "x-www-form-urlencoded",
);

/**
 * text
 */
export const TextType = new Type("text");

/**
 * text/plain
 */
export const TextPlainType = TextType.subtype("plain");

/**
 * text/html
 * @see {@link https://www.iana.org/assignments/media-types/text/html IANA Media Types text/html}
 */
export const TextHtmlType = TextType.subtype("html");

/**
 * text/javascript
 * @see {@link https://www.iana.org/assignments/media-types/text/javascript IANA Media Types text/javascript}
 */
export const TextJavaScriptType = TextType.subtype("javascript");

/**
 * text/xml
 * @see {@link https://www.iana.org/assignments/media-types/text/xml IANA Media Types text/xml}
 */
export const TextXmlType = TextType.subtype("xml");
